import { render, staticRenderFns } from "./water_right.vue?vue&type=template&id=0b0101f2&scoped=true&"
import script from "./water_right.vue?vue&type=script&lang=js&"
export * from "./water_right.vue?vue&type=script&lang=js&"
import style0 from "./water_right.vue?vue&type=style&index=0&id=0b0101f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0101f2",
  null
  
)

export default component.exports